"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const ForwardArrow = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M16.979 12.295l-5.444 5.444a.751.751 0 0 0-.005 1.065.755.755 0 0 0 1.065-.005l6.626-6.625a.742.742 0 0 0 .303-.544.745.745 0 0 0-.302-.679l-6.627-6.626a.751.751 0 0 0-1.065-.005.755.755 0 0 0 .005 1.065l5.409 5.41H4.735a.745.745 0 0 0-.744.75c0 .414.342.75.744.75H16.98z", children: " " })
] });
var ForwardArrow_default = ForwardArrow;
export {
  ForwardArrow_default as default
};
